import {Pipe, PipeTransform} from '@angular/core';
import {catchError, map, Observable, of, startWith} from 'rxjs';
import {DistanceService} from "../services/helper/distance.service";

@Pipe({
  name: 'distancePipe',
  pure: false,
})
export class DistancePipe implements PipeTransform {
  private cached: { [key: string]: Observable<string> } = {};

  constructor(private readonly distanceService: DistanceService) {
  }


  transform(from: [number, number], toLat: number, toLng: number): Observable<string> {
    const to: [number, number] = [toLng, toLat]; // dikkat! önce lng sonra lat
    const key = `${from[0]}-${from[1]}-${to[0]}-${to[1]}`;

    if (!this.cached[key]) {
      this.cached[key] = this.distanceService.getDistance(from, to).pipe(
        map((res) => {
          const distanceInKm = res.features[0].properties.summary.distance / 1000;
          return `${distanceInKm.toFixed(2)} km`;
        }),
        catchError(() => of('Hesaplanamadı')),
        startWith('...')
      );
    }

    return this.cached[key];
  }
}
